import React from "react";
import { InputNumber } from "primereact/inputnumber";
import { InputMask } from "primereact/inputmask";
import { CapData, PeriodForm } from "../types";
import { minToHHmm, hhmmToMin } from "../utils";
import Field from "./Field";

type Props = {
  icon: string;
  label: string;
  periodLabel?: string;
  accentColor: string;
  period: PeriodForm;
  cap: CapData;
  activationPrice: number;
  onChange: (p: PeriodForm) => void;
};

const PeriodSection: React.FC<Props> = ({
  icon,
  label,
  periodLabel,
  accentColor,
  period,
  cap,
  activationPrice,
  onChange,
}) => {
  const set = (key: keyof PeriodForm) => (v: number) =>
    onChange({ ...period, [key]: v });

  return (
    <div className="te-period">
      <div className="te-period-header">
        <i className={icon} style={{ color: accentColor }} />
        <span>{label}</span>
        {periodLabel && <span className="te-period-badge">{periodLabel}</span>}
      </div>

      <div className="te-period-body">
        {/* Editable fields */}
        <div className="te-fields-grid">
          <Field label="Energy fee" unit="€/kWh">
            <InputNumber
              value={period.energyFee}
              onValueChange={(e) => set("energyFee")(e.value ?? 0)}
              min={0}
              max={1}
              minFractionDigits={2}
              maxFractionDigits={2}
              className="te-input w-full"
            />
          </Field>

          <Field label="Blocking fee" unit="€/h">
            <InputNumber
              value={period.blockingFee}
              onValueChange={(e) => set("blockingFee")(e.value ?? 0)}
              min={0}
              max={24}
              minFractionDigits={2}
              maxFractionDigits={2}
              className="te-input w-full"
            />
          </Field>

          <Field label="Starts after" unit="HH:mm">
            <InputMask
              mask="99:99"
              value={minToHHmm(period.blockingFeeAfterMin)}
              onChange={(e) => set("blockingFeeAfterMin")(hhmmToMin(e.value))}
              className="te-input-mask w-full"
            />
          </Field>
        </div>

        <div className="te-fields-divider" />

        {/* Fixed fields */}
        <div className="te-fields-grid">
          <Field label="Activation fee" unit="€" fixed>
            <InputNumber
              value={parseFloat(activationPrice.toFixed(2))}
              disabled
              minFractionDigits={2}
              maxFractionDigits={2}
              className="te-input w-full"
            />
          </Field>

          <Field label="Blocking fee cap" unit="€" fixed>
            <InputNumber
              value={parseFloat(cap.price.toFixed(2))}
              disabled
              minFractionDigits={2}
              maxFractionDigits={2}
              className="te-input w-full"
            />
          </Field>
        </div>
      </div>
    </div>
  );
};

export default PeriodSection;
